/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import { Box, Grid } from "@mui/material";
import React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import Styles from "../Subsriptionstyles";
import InputField from "../../../../components/common/new/InputField/InputField";

function AdvanceSearch({
  handleDateChangeFrom,
  handleDateChangeTo,
  dateValueFrom,
  dateValueTo,
  hideDateFilters = false,
}) {
  // OLD: Always showed date filters
  // return (
  //   <Box>
  //     <Box
  //       sx={{
  //         width: { xs: "100%", sm: "100%", md: "50%" },
  //       }}
  //     >
  //       <Grid container rowSpacing={8} columnSpacing={5}>
  //         <Grid item xs={6}>
  //           <LocalizationProvider dateAdapter={AdapterDayjs}>
  //             <DatePicker
  //               label="Select Month From"
  //               views={["year", "month"]}
  //               name="monthFrom"
  //               value={dateValueFrom}
  //               disableFuture
  //               onChange={handleDateChangeFrom}
  //               renderInput={(props) => <InputField {...props} />}
  //             />
  //           </LocalizationProvider>
  //         </Grid>
  //         <Grid item xs={6}>
  //           {/* <InputField
  //             label="Number of Months"
  //             name="numberOfMonths"
  //             style={Styles.textfieldStyle}
  //           /> */}
  //           <LocalizationProvider dateAdapter={AdapterDayjs}>
  //             <DatePicker
  //               label="Select Month To"
  //               views={["year", "month"]}
  //               name="monthTo"
  //               value={dateValueTo}
  //               disableFuture
  //               onChange={handleDateChangeTo}
  //               renderInput={(props) => <InputField {...props} />}
  //             />
  //           </LocalizationProvider>
  //         </Grid>
  //       </Grid>
  //     </Box>
  //     <Grid item md={8} sm={12} spacing={2} />
  //   </Box>
  // );

  // NEW: Conditionally render date filters based on hideDateFilters prop
  if (hideDateFilters) {
    return (
      <Box>
        <Grid item md={8} sm={12} spacing={2} />
      </Box>
    );
  }

  return (
    <Box>
      <Box
        sx={{
          width: { xs: "100%", sm: "100%", md: "50%" },
        }}
      >
        <Grid container rowSpacing={8} columnSpacing={5}>
          <Grid item xs={6}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Select Month From"
                views={["year", "month"]}
                name="monthFrom"
                value={dateValueFrom}
                disableFuture
                onChange={handleDateChangeFrom}
                renderInput={(props) => <InputField {...props} />}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={6}>
            {/* <InputField
              label="Number of Months"
              name="numberOfMonths"
              style={Styles.textfieldStyle}
            /> */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Select Month To"
                views={["year", "month"]}
                name="monthTo"
                value={dateValueTo}
                disableFuture
                onChange={handleDateChangeTo}
                renderInput={(props) => <InputField {...props} />}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
      </Box>
      <Grid item md={8} sm={12} spacing={2} />
    </Box>
  );
}

export default AdvanceSearch;
